import { Action } from '@ngrx/store';

import { Account } from '@libs/src/models/account.model';

export const PROFILE_LOADED = '[profile] Loaded';
export const PROFILE_RESET = '[profile] Reset';
export const PROFILE_DELETE_ACCOUNT = '[profile] Delete Account';
export const PROFILE_DELETE_ACCOUNT_ERROR = '[profile] Delete Account Error';
export const PROFILE_EDITED = '[profile] Edited Profile';

export class ProfileAction implements Action {
  constructor(
    public type = '',
    public payload?: any,
  ) {}
}

export function LoadProfile(payload: any): ProfileAction {
  return new ProfileAction(PROFILE_LOADED, payload);
}

export function ResetProfile(): ProfileAction {
  return new ProfileAction(PROFILE_RESET);
}

export function DeleteProfile(payload: { account: Account; params: any }) {
  return new ProfileAction(PROFILE_DELETE_ACCOUNT, payload);
}

export function DeleteProfileError() {
  return new ProfileAction(PROFILE_DELETE_ACCOUNT_ERROR);
}

export function EditedProfile(isEdited: boolean) {
  return new ProfileAction(PROFILE_EDITED, isEdited);
}
